// extracted by mini-css-extract-plugin
export var current = "pagination-module--current--Q8jRF";
export var disabled = "pagination-module--disabled--O3k-I";
export var dots = "pagination-module--dots--3tqu8";
export var next = "pagination-module--next--kuH+y";
export var pagination = "pagination-module--pagination--5TBQ0";
export var paginationInner = "pagination-module--paginationInner--oJCbW";
export var prev = "pagination-module--prev--yE0vo";
export var sbShowMain = "pagination-module--sb-show-main--1lLGr";